import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { getActivityAttendeeCountService } from '../../../store/attendees-store/activity-attendee-count-service/activity-attendee-count-service-instance';

const ActiveAttendeesCountContainer: FC = () => {
  const specialRuleForSingular = 1;
  const activeAttendeeNumber = getActivityAttendeeCountService().activeAttendeeNumber;
  const correctGrammaticalNumberCondition = activeAttendeeNumber === specialRuleForSingular ? 'Attendee' : 'Attendees';

  return (
    <section className='active-attendees-count-container'>
      <div className='active-attendees-count-number'>
        {activeAttendeeNumber}
      </div>
      <div className='active-attendees-count-text'>
        <p>Active</p>
        <p>{correctGrammaticalNumberCondition}</p>
      </div>
    </section>
  );
};

export default observer(ActiveAttendeesCountContainer);